import { put, takeLatest } from 'redux-saga/effects';
import helpers from 'utils/helpers';
const { rp, setJwt } = helpers;

const LOGIN_REQUEST = 'LOGIN_REQUEST';
const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const LOGIN_FAILURE = 'LOGIN_FAILURE';

const LOGIN_AS_REQUEST = 'LOGIN_AS_REQUEST';

const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

const REGISTER_REQUEST = 'REGISTER_REQUEST';
const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
const REGISTER_FAILURE = 'REGISTER_FAILURE';

const SET_PASSWORD_REQUEST = 'SET_PASSWORD_REQUEST';
const SET_PASSWORD_SUCCESS = 'SET_PASSWORD_SUCCESS';
const SET_PASSWORD_FAILURE = 'SET_PASSWORD_FAILURE';

const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

const REQUEST_RESET_PASSWORD_REQUEST = 'REQUEST_RESET_PASSWORD_REQUEST';
const REQUEST_RESET_PASSWORD_SUCCESS = 'REQUEST_RESET_PASSWORD_SUCCESS';
const REQUEST_RESET_PASSWORD_FAILURE = 'REQUEST_RESET_PASSWORD_FAILURE';

const GOOGLE_LOGIN_REQUEST = 'GOOGLE_LOGIN_REQUEST';
const GOOGLE_LOGIN_SUCCESS = 'GOOGLE_LOGIN_SUCCESS';
const GOOGLE_LOGIN_FAILURE = 'GOOGLE_LOGIN_FAILURE';

const AUTHORIZATION_REQUEST = 'AUTHORIZATION_REQUEST';
const AUTHORIZATION_SUCCESS = 'AUTHORIZATION_SUCCESS';
const AUTHORIZATION_FAILURE = 'AUTHORIZATION_FAILURE';

const UPDATE_INFO_REQUEST = 'UPDATE_INFO_REQUEST';
const UPDATE_INFO_SUCCESS = 'UPDATE_INFO_SUCCESS';
const UPDATE_INFO_FAILURE = 'UPDATE_INFO_FAILURE';

export const loginRequest = params => ({
  type: LOGIN_REQUEST,
  ...params
});

export const loginAsRequest = params => ({
  type: LOGIN_AS_REQUEST,
  ...params
});

export const logoutRequest = params => ({
  type: LOGOUT_REQUEST,
  ...params
});

export const registerRequest = params => ({
  type: REGISTER_REQUEST,
  ...params
});

export const setPasswordRequest = params => ({
  type: SET_PASSWORD_REQUEST,
  ...params
});

export const resetPasswordRequest = params => ({
  type: RESET_PASSWORD_REQUEST,
  ...params
});

export const requestResetPasswordRequest = params => ({
  type: REQUEST_RESET_PASSWORD_REQUEST,
  ...params
});

export const googleLoginRequest = params => ({
  type: GOOGLE_LOGIN_REQUEST,
  ...params
});

export const authorizationRequest = params => ({
  type: AUTHORIZATION_REQUEST,
  ...params
});

export const updateInfoRequest = params => ({
  type: UPDATE_INFO_REQUEST,
  ...params
});

function* login(action) {
  const { email, password } = action;

  var options = {
    method: 'POST',
    uri: process.env.REACT_APP_BASE_URL + '/auth/login',
    body: {
      email,
      password
    },
    json: true
  };

  try {
    const data = yield rp(options);

    if (data.success) {
      const { token, user } = setJwt(data.data.accessToken);

      const { ref, email, name, phone, phoneCc, userType, basic } = user;

      yield put({
        type: LOGIN_SUCCESS,
        user: token ? ref : false,
        email,
        name,
        phone,
        phoneCc,
        userType,
        basic
      });
      helpers.message.success(window.t('error_code.login-success'), 'auth');
    } else {
      yield put({ type: LOGIN_FAILURE });
      helpers.message.error(window.t('error_code.login-fail'), 'auth');
    }
  } catch (e) {
    console.error(e);
    yield put({ type: LOGIN_FAILURE });
    helpers.message.error(window.t('error_code.login-error'), 'auth');
  }
}

function* loginAs(action) {
  const { access } = action;
  let buff = new Buffer(access, 'base64');
  let base64data = buff.toString('utf8');

  try {
    const data = JSON.parse(base64data);

    if (data && data.accessToken) {
      const { token, user } = setJwt(data.accessToken);

      localStorage.setItem('user', JSON.stringify(user));

      const {
        ref,
        email,
        name,
        phone,
        phoneCc,
        userType,
        basic,
        adminLogin
      } = user;

      yield put({
        type: AUTHORIZATION_SUCCESS,
        user: token ? ref : false,
        email,
        name,
        phone,
        phoneCc,
        userType,
        basic,
        adminLogin
      });
    } else {
      yield put({ type: AUTHORIZATION_FAILURE });
    }
  } catch (e) {
    console.error(e);
    yield put({ type: AUTHORIZATION_FAILURE });
  }
}

function* logout(action) {
  var options = {
    method: 'POST',
    uri: process.env.REACT_APP_BASE_URL + '/auth/logout',
    json: true
  };

  try {
    const data = yield rp(options);

    localStorage.removeItem('token');

    if (data.success) {
      yield put({
        type: LOGOUT_SUCCESS
      });

      helpers.message.success(window.t('error_code.logout-success'), 'auth');
      window.location.reload();
    } else {
      yield put({ type: LOGOUT_FAILURE });
      helpers.message.error(window.t('error_code.logout-fail'), 'auth');
    }
  } catch (e) {
    console.error(e);
    yield put({ type: LOGOUT_FAILURE });
    helpers.message.error(window.t('error_code.logout-fail'), 'auth');
  }
}

function* register(action) {
  const { email, password } = action;
  const promo = action.promo ?? '';

  var options = {
    method: 'POST',
    uri: process.env.REACT_APP_BASE_URL + '/auth/register',
    body: {
      email,
      password,
      promo
    },
    json: true
  };

  try {
    const data = yield rp(options);

    if (data.success) {
      const { token, user } = setJwt(data.data.accessToken);

      const { ref, email, name, phone, phoneCc, userType, basic } = user;

      yield put({
        type: REGISTER_SUCCESS,
        user: token ? ref : false,
        email,
        name,
        phone,
        phoneCc,
        userType,
        basic
      });
      helpers.message.success(window.t('error_code.register-success'), 'auth');
    } else {
      if (data.code === '1120') {
        helpers.message.error(window.t('error_code.register-1120'), 'auth');
      } else {
        helpers.message.error(window.t('error_code.register-fail'), 'auth');
      }

      yield put({ type: REGISTER_FAILURE });
    }
  } catch (e) {
    console.error(e);
    yield put({ type: REGISTER_FAILURE });
    helpers.message.error(window.t('error_code.register-fail'), 'auth');
  }
}

function* setPassword(action) {
  const { password, token } = action;

  var options = {
    method: 'POST',
    uri: process.env.REACT_APP_BASE_URL + '/auth/set-password',
    body: {
      password,
      token
    },
    json: true
  };

  try {
    const data = yield rp(options);

    if (data.success) {
      const { token, user } = helpers.getJwt();

      if (token && user) {
        const { ref, email, name, phone, phoneCc, userType, basic } = user;

        yield put({
          type: SET_PASSWORD_SUCCESS,
          user: ref,
          email,
          name,
          phone,
          phoneCc,
          userType,
          basic
        });
      } else {
        yield put({
          type: SET_PASSWORD_SUCCESS,
          user: false
        });
      }
      helpers.message.success(window.t('error_code.reset-success'), 'auth');
    } else {
      yield put({ type: SET_PASSWORD_FAILURE });
      helpers.message.error(window.t('error_code.reset-fail'), 'auth');
    }
  } catch (e) {
    console.error(e);
    yield put({ type: SET_PASSWORD_FAILURE });
    helpers.message.error(window.t('error_code.reset-fail'), 'auth');
  }
}

function* resetPassword(action) {
  const { password, token } = action;

  var options = {
    method: 'POST',
    uri: process.env.REACT_APP_BASE_URL + '/auth/reset-password',
    body: {
      password,
      token
    },
    json: true
  };

  try {
    const data = yield rp(options);

    if (data.success) {
      const { token, user } = helpers.getJwt();

      if (token && user) {
        const { ref, email, name, phone, phoneCc, userType, basic } = user;

        yield put({
          type: RESET_PASSWORD_SUCCESS,
          user: ref,
          email,
          name,
          phone,
          phoneCc,
          userType,
          basic
        });
      } else {
        yield put({
          type: RESET_PASSWORD_SUCCESS,
          user: false
        });
      }
      helpers.message.success(window.t('error_code.reset-success'), 'auth');
    } else {
      yield put({ type: RESET_PASSWORD_FAILURE });
      helpers.message.error(window.t('error_code.reset-fail'), 'auth');
    }
  } catch (e) {
    console.error(e);
    yield put({ type: RESET_PASSWORD_FAILURE });
    helpers.message.error(window.t('error_code.reset-fail'), 'auth');
  }
}

function* requestResetPassword(action) {
  const { email } = action;

  var options = {
    method: 'POST',
    uri: process.env.REACT_APP_BASE_URL + '/auth/reset-password-request',
    body: {
      email
    },
    json: true
  };

  try {
    yield rp(options);

    yield put({
      type: REQUEST_RESET_PASSWORD_SUCCESS
    });

    helpers.message.success(window.t('error_code.email-success'), 'auth');
  } catch (e) {
    console.error(e);
    yield put({ type: REQUEST_RESET_PASSWORD_FAILURE });
    helpers.message.error(window.t('error_code.email-fail'), 'auth');
  }
}

function* googleLogin(action) {
  const { accessToken } = action;

  var options = {
    method: 'POST',
    uri: process.env.REACT_APP_BASE_URL + '/auth/google-login',
    body: {
      accessToken
    },
    json: true
  };

  try {
    const data = yield rp(options);

    if (data.success) {
      const { token, user } = setJwt(data.data.accessToken);

      const {
        ref,
        email,
        name,
        phone,
        phoneCc,
        userType,
        basic,
        newUser
      } = user;

      yield put({
        type: GOOGLE_LOGIN_SUCCESS,
        user: token ? ref : false,
        email,
        name,
        phone,
        phoneCc,
        userType,
        basic,
        newUser
      });
      helpers.message.success(window.t('error_code.login-success'), 'auth');
    } else {
      yield put({ type: GOOGLE_LOGIN_FAILURE });
      helpers.message.error(window.t('error_code.login-error'), 'auth');
    }
  } catch (e) {
    console.error(e);
    yield put({ type: GOOGLE_LOGIN_FAILURE });
    helpers.message.error(window.t('error_code.login-error'), 'auth');
  }
}

function* authorization(action) {
  const { user, token } = helpers.getJwt();

  try {
    if (user && token) {
      const {
        ref,
        email,
        name,
        phone,
        phoneCc,
        userType,
        basic,
        adminLogin
      } = user;

      yield put({
        type: AUTHORIZATION_SUCCESS,
        user: token ? ref : false,
        email,
        name,
        phone,
        phoneCc,
        userType,
        basic,
        adminLogin
      });
    } else {
      yield put({ type: AUTHORIZATION_FAILURE });
    }
  } catch (e) {
    console.error(e);
    yield put({ type: AUTHORIZATION_FAILURE });
  }
}

function* updateInfo(action) {
  const {
    name,
    phone,
    phoneCc,
    userType,
    company,
    whatsapp,
    minAvgShipments,
    maxAvgShipments,
    minAvgWeight,
    maxAvgWeight,
    categories,
    categoryDescription
  } = action;
  var options = {
    method: 'POST',
    uri: process.env.REACT_APP_BASE_URL + '/auth/basic',
    body: {
      name,
      phone,
      phoneCc,
      userType,
      company,
      whatsapp,
      minAvgShipments,
      maxAvgShipments,
      minAvgWeight,
      maxAvgWeight,
      categories,
      categoryDescription
    },
    json: true
  };

  try {
    const data = yield rp(options);

    if (data.success) {
      const { user } = setJwt(data.data.accessToken);

      const { name, phone, phoneCc, userType, basic } = user;

      yield put({
        type: UPDATE_INFO_SUCCESS,
        name,
        phone,
        phoneCc,
        userType,
        basic,
        company
      });
      // helpers.message.success('更新資料成功', 'auth');
    } else {
      yield put({ type: UPDATE_INFO_FAILURE });
      helpers.message.error(window.t('error_code.update-fail'), 'auth');
    }
  } catch (e) {
    console.error(e);
    yield put({ type: UPDATE_INFO_FAILURE });
    helpers.message.error(window.t('error_code.update-fail'), 'auth');
  }
}

function* saga() {
  yield takeLatest(LOGIN_REQUEST, login);
  yield takeLatest(LOGIN_AS_REQUEST, loginAs);
  yield takeLatest(LOGOUT_REQUEST, logout);
  yield takeLatest(REGISTER_REQUEST, register);
  yield takeLatest(SET_PASSWORD_REQUEST, setPassword);
  yield takeLatest(RESET_PASSWORD_REQUEST, resetPassword);
  yield takeLatest(REQUEST_RESET_PASSWORD_REQUEST, requestResetPassword);
  yield takeLatest(GOOGLE_LOGIN_REQUEST, googleLogin);
  yield takeLatest(AUTHORIZATION_REQUEST, authorization);
  yield takeLatest(UPDATE_INFO_REQUEST, updateInfo);
}

const reducer = (state = {}, action) => {
  const {
    user,
    email,
    name,
    phone,
    phoneCc,
    userType,
    basic,
    newUser,
    adminLogin,
    company
  } = action;

  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        user: false,
        loading: true,
        loginSuccess: false
      };
    case LOGIN_AS_REQUEST:
      return {
        ...state,
        user: false,
        loading: true,
        loginSuccess: false
      };
    case LOGIN_SUCCESS:
      window.dataLayer.push({
        event: 'Login Success',
        userId: user,
        email,
        name
      });

      return {
        ...state,
        user,
        email,
        name,
        phone,
        phoneCc,
        userType,
        basic,
        loading: false,
        loginSuccess: true
      };
    case LOGIN_FAILURE:
      window.dataLayer.push({
        event: 'Login Fail',
        errorMessage: window.t('error_code.login-fail'),
        errorCode: 'login-fail'
      });

      return {
        ...state,
        user: false,
        loading: false,
        loginSuccess: false
      };
    case LOGOUT_REQUEST:
      return {
        ...state,
        loading: true,
        logoutSuccess: false
      };
    case LOGOUT_SUCCESS:
      window.dataLayer.push({
        event: 'Logout Success',
        userId: undefined
      });

      return {
        ...state,
        user: false,
        email: '',
        name: '',
        phone: '',
        phoneCc: '',
        userType: null,
        basic: false,
        loading: false,
        logoutSuccess: true
      };
    case LOGOUT_FAILURE:
      return {
        ...state,
        loading: false,
        logoutSuccess: false
      };
    case REGISTER_REQUEST:
      return {
        ...state,
        user: false,
        loading: true,
        registerSuccess: false
      };
    case REGISTER_SUCCESS:
      window.dataLayer.push({
        event: 'Register Success',
        userId: user,
        email
      });

      return {
        ...state,
        user,
        email,
        name,
        phone,
        phoneCc,
        userType,
        basic,
        loading: false,
        registerSuccess: true
      };
    case REGISTER_FAILURE:
      return {
        ...state,
        user: false,
        loading: false,
        registerSuccess: false
      };
    case SET_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        passwordChanged: false
      };
    case SET_PASSWORD_SUCCESS:
      window.dataLayer.push({
        event: 'Set Password Success',
        userId: user
      });

      return {
        ...state,
        user,
        email,
        name,
        phone,
        phoneCc,
        userType,
        basic,
        loading: false,
        passwordChanged: true
      };
    case SET_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
        passwordChanged: false
      };
    case RESET_PASSWORD_REQUEST:
      return {
        ...state,
        user: false,
        loading: true,
        passwordChanged: false
      };
    case RESET_PASSWORD_SUCCESS:
      window.dataLayer.push({
        event: 'Reset Password Success',
        userId: user
      });

      return {
        ...state,
        user,
        email,
        name,
        userType,
        phone,
        phoneCc,
        basic,
        loading: false,
        passwordChanged: true
      };
    case RESET_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
        passwordChanged: false
      };
    case REQUEST_RESET_PASSWORD_REQUEST:
      return {
        ...state,
        user: false,
        loading: true,
        requestResetPasswordSuccess: false
      };
    case REQUEST_RESET_PASSWORD_SUCCESS:
      window.dataLayer.push({
        event: 'Reset Password Request Success',
        userId: user
      });

      return {
        ...state,
        loading: false,
        requestResetPasswordSuccess: true
      };
    case REQUEST_RESET_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
        requestResetPasswordSuccess: false
      };
    case GOOGLE_LOGIN_REQUEST:
      return {
        ...state,
        user: false,
        loading: true,
        loginSuccess: false
      };
    case GOOGLE_LOGIN_SUCCESS:
      window.dataLayer.push({
        event: newUser ? 'Register Success' : 'Google Login Success',
        userId: user,
        email,
        name,
        userData: {
          linkedGoogle: true
        }
      });

      return {
        ...state,
        user,
        email,
        name,
        phone,
        phoneCc,
        userType,
        basic,
        loading: false,
        loginSuccess: true,
        registerSuccess: newUser ? true : undefined
      };
    case GOOGLE_LOGIN_FAILURE:
      window.dataLayer.push({
        event: 'Login Fail',
        errorMessage: window.t('error_code.login-fail'),
        errorCode: 'google-login-fail'
      });

      return {
        ...state,
        user: false,
        loading: false,
        loginSuccess: false
      };
    case AUTHORIZATION_REQUEST:
      return {
        ...state,
        user: undefined,
        authRequestSuccess: false,
        loading: true
      };
    case AUTHORIZATION_SUCCESS:
      window.dataLayer.push({
        userId: user
      });

      return {
        ...state,
        user,
        email,
        name,
        phone,
        phoneCc,
        userType,
        basic,
        adminLogin,
        authRequestSuccess: true,
        loading: false
      };
    case AUTHORIZATION_FAILURE:
      return {
        ...state,
        user: false,
        authRequestSuccess: false,
        loading: false
      };
    case UPDATE_INFO_REQUEST:
      return {
        ...state,
        loading: true,
        updateBasicSuccess: false
      };
    case UPDATE_INFO_SUCCESS:
      window.dataLayer.push({
        event: 'Update Basic Success',
        userData: {
          userType: userType,
          name: name,
          phone: phone,
          phoneCc: phoneCc,
          company
        }
      });

      return {
        ...state,
        name,
        phone,
        phoneCc,
        userType,
        basic,
        loading: false,
        updateBasicSuccess: true
      };
    case UPDATE_INFO_FAILURE:
      return {
        ...state,
        loading: false,
        updateBasicSuccess: false
      };
    default:
      return state;
  }
};

export default {
  saga,
  reducer
};
